module.exports = __webpack_public_path__ + "static/img/elsolution.0ea47d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/elsolution.png
// module id = vXTb
// module chunks = 0